import { isEmpty } from '@/common/js/utils'

export default {
  methods: {
    // 验证方法
    validate() {
      if (!this.verify) return

      // 必填
      if (this.required && isEmpty(this.value)) {
        this.msg = `${this.description}不能为空`
        this.$emit('on-verify', { name: this.name, val: false })
        return
      }

      // 长度
      if (this.max && this.max < this.len) {
        this.msg = `${this.description}超过字符限制`
        this.$emit('on-verify', { name: this.name, val: false })
        return
      }
      if (this.min && this.min > this.len) {
        this.msg = `${this.description}未满足字符限制`
        this.$emit('on-verify', { name: this.name, val: false })
        return
      }

      // 验证
      if (this.pattern && this.name === 'title') {
        const regx = new RegExp(this.pattern)
        if (!regx.test(this.title)) {
          this.msg = `${this.description}不是有效的值`
          this.$emit('on-verify', { name: this.name, val: false })
          return
        }
      }

      if (this.pattern && this.name === 'brand') {
        const regx = new RegExp(this.pattern)
        if (!regx.test(this.brand)) {
          this.msg = `${this.description}不是有效的值`
          this.$emit('on-verify', { name: this.name, val: false })
          return
        }
      }

      if (this.pattern && this.name === 'subtitle') {
        const regx = new RegExp(this.pattern)
        if (!regx.test(this.subtitle)) {
          this.msg = `${this.description}不是有效的值`
          this.$emit('on-verify', { name: this.name, val: false })
          return
        }
      }

      if (this.pattern && this.name === 'url') {
        const regx = new RegExp(this.pattern)
        if (!regx.test(this.url)) {
          this.msg = `${this.description}不是有效的值`
          this.$emit('on-verify', { name: this.name, val: false })
          return
        }
      }

      this.$emit('on-verify', { name: this.name, val: true })
    }
  },
  watch: {
    value() {
      this.msg = ''
      this.validate()
    },
    // 验证模式
    verify(nVal) {
      this.msg = ''
      if (nVal) this.validate()
    }
  },
  data() {
    return {
      msg: ''
    }
  }
}
